var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 187,
    viewBox: "0 0 152 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.999 167.479C117.545 167.479 151.225 133.799 151.225 92.2529C151.225 50.707 117.545 17.0273 75.999 17.0273C34.4531 17.0273 0.773438 50.707 0.773438 92.2529C0.773438 133.799 34.4531 167.479 75.999 167.479Z",
    fill: "#F1F5F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_223_1703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.127 60.1602H32.8686C30.0988 60.1602 27.8535 62.4055 27.8535 65.1752V170.491C27.8535 173.261 30.0988 175.506 32.8686 175.506H119.127C121.897 175.506 124.142 173.261 124.142 170.491V65.1752C124.142 62.4055 121.897 60.1602 119.127 60.1602Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9681 75.2031H39.8899C38.228 75.2031 36.8809 76.5503 36.8809 78.2121C36.8809 79.874 38.228 81.2212 39.8899 81.2212H65.9681C67.6299 81.2212 68.9771 79.874 68.9771 78.2121C68.9771 76.5503 67.6299 75.2031 65.9681 75.2031Z",
    fill: "#E6ECEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0222 88.2422H39.8899C38.228 88.2422 36.8809 89.5894 36.8809 91.2512C36.8809 92.913 38.228 94.2602 39.8899 94.2602H84.0222C85.6841 94.2602 87.0313 92.913 87.0313 91.2512C87.0313 89.5894 85.6841 88.2422 84.0222 88.2422Z",
    fill: "#D3DCDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9681 102.285H39.8899C38.228 102.285 36.8809 103.632 36.8809 105.294C36.8809 106.956 38.228 108.303 39.8899 108.303H65.9681C67.6299 108.303 68.9771 106.956 68.9771 105.294C68.9771 103.632 67.6299 102.285 65.9681 102.285Z",
    fill: "#E6ECEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0222 115.324H39.8899C38.228 115.324 36.8809 116.671 36.8809 118.333C36.8809 119.995 38.228 121.342 39.8899 121.342H84.0222C85.6841 121.342 87.0313 119.995 87.0313 118.333C87.0313 116.671 85.6841 115.324 84.0222 115.324Z",
    fill: "#D3DCDF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9681 129.363H39.8899C38.228 129.363 36.8809 130.71 36.8809 132.372C36.8809 134.034 38.228 135.381 39.8899 135.381H65.9681C67.6299 135.381 68.9771 134.034 68.9771 132.372C68.9771 130.71 67.6299 129.363 65.9681 129.363Z",
    fill: "#E6ECEE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0222 142.402H39.8899C38.228 142.402 36.8809 143.75 36.8809 145.411C36.8809 147.073 38.228 148.42 39.8899 148.42H84.0222C85.6841 148.42 87.0313 147.073 87.0313 145.411C87.0313 143.75 85.6841 142.402 84.0222 142.402Z",
    fill: "#D3DCDF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_223_1703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.129 9H32.8705C30.1008 9 27.8555 11.2453 27.8555 14.015V44.1053C27.8555 46.875 30.1008 49.1203 32.8705 49.1203H119.129C121.899 49.1203 124.144 46.875 124.144 44.1053V14.015C124.144 11.2453 121.899 9 119.129 9Z",
    fill: "#B5C6CB"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.97 20.0312H39.8918C38.23 20.0312 36.8828 21.3784 36.8828 23.0403C36.8828 24.7021 38.23 26.0493 39.8918 26.0493H65.97C67.6319 26.0493 68.9791 24.7021 68.9791 23.0403C68.9791 21.3784 67.6319 20.0312 65.97 20.0312Z",
    fill: "#F9FBFB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0242 33.0703H39.8918C38.23 33.0703 36.8828 34.4175 36.8828 36.0793C36.8828 37.7412 38.23 39.0884 39.8918 39.0884H84.0242C85.686 39.0884 87.0332 37.7412 87.0332 36.0793C87.0332 34.4175 85.686 33.0703 84.0242 33.0703Z",
    fill: "#D3DCDF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_223_1703",
    x: 20.0535,
    y: 55.3602,
    width: 111.889,
    height: 130.948,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.170833 0 0 0 0 0.170833 0 0 0 0 0.170833 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_223_1703"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_223_1703",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_223_1703",
    x: 21.8555,
    y: 0,
    width: 108.289,
    height: 52.1211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_223_1703"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_223_1703",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProject);
export default __webpack_public_path__ + "static/media/empty_project.861307ea60c474bc6ade2a8a9f9e1efe.svg";
export { ForwardRef as ReactComponent };